import { track } from 'lib/babylistHealthAnalytics'
import { decorateEventPayload } from './decorateEventPayload'

export interface PumpCatalogSelectedEventMetadata {
  insuranceProvider: string
  insuranceProviderId: number
  insuredState: string
  emailProvided: boolean
  emailExperimentGroup: string
}

export const pumpCatalogSelectedEvent =
  (tracker: any) =>
  ({
    insuranceProvider,
    insuranceProviderId,
    insuredState,
    emailProvided,
    emailExperimentGroup,
  }: PumpCatalogSelectedEventMetadata) => {
    const payload = decorateEventPayload({
      event: track.pumpCatalogSelected,
      insuranceProvider,
      insuranceProviderId,
      insuredState,
      emailProvided,
      emailExperimentGroup,
    })
    tracker.trackEvent(payload)
  }
